module.exports = __webpack_public_path__ + "img/financers-logo.f4185a11.svg";